import { Button, ButtonProps } from "@mui/material";
import { History } from "@mui/icons-material";

export type ResetFiltersButtonProps = ButtonProps;

export function ResetFiltersButton({
  ...buttonProps
}: ResetFiltersButtonProps) {
  return (
    <Button
      variant="text"
      color="secondary"
      startIcon={<History />}
      sx={{ textTransform: "none", whiteSpace: "nowrap" }}
      {...buttonProps}
    >
      Reset All Filters
    </Button>
  );
}
